import { Row, Col, Container } from "react-bootstrap";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { GenericTooltip } from "../form/GenericTooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import JSONPretty from "../../jsonPrettyOverride/JSONPretty";
import classes from "../../../pages/IntegrationWizard.module.scss"
import { useContext, useEffect, useState } from "react";
import { DDD, E2Data, tx } from "../../../lib/ddd/ddd";
import { OrgIdContext } from "../../../store/orgId_context";
import Curl from "../../APIPlaygroundComponents/Curl";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from "../../UI/Button";
import LoadingDots from "../../UI/LoadingDots";
import JsonObject from "../../APIPlaygroundComponents/JsonObject";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Tabs, Tab, Box,Select, MenuItem, Tooltip as MuiTooltip } from "@mui/material";
import { NotificationManager} from 'react-notifications';
import useInterval from "../../../lib/useInterval";
/*import axios from "axios";
import { RpcClient, getStdRpcContext, initRpcClient } from "../../../lib/ddd/RPCAxiosClient"*/

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
const data = new E2Data("EU_Invoices");
data.filter="DeviceId__AssignedTo = 'CKI'";
data.orderBy = "DateTimeCreate desc";
data.take = 1;
data.includeCount = true;

const Execute = ({json, onExecute, invoiceId}) =>{
    const { integrationDevice} = useContext(OrgIdContext);
    const [curlCommand, setCurlCommand] = useState("");
    const [sendingRequestLoad, setSendingRequestLoad] = useState(false);
    const [response, setResponse] = useState(null);
    const [lastFieldChange, setLastFieldChange] = useState();
    const [mode, setMode] = useState("Website")
    const [firstLoad, setFirstLoad] = useState(false);
    const [numOfInvoices, setNumOfInvoices] = useState(0);

    let _firstLoad = firstLoad;
    let _invoiceId = invoiceId;
    let _sendingRequestLoad = sendingRequestLoad;
    let _numOfInvoices = numOfInvoices;

    useEffect(() => {
        const jsonString = JSON.stringify(JSON.stringify(json));

        const curlCmd = tx(`curl -X POST https://${window.location.hostname}/api/service/EUeInvoices.DDDI_Save -H "Authorization: IoT ${integrationDevice}:EUeInvoices" -H "Content-Type: application/json" -d ${jsonString}`);
        setCurlCommand(curlCmd);
    }, [json, integrationDevice])

    
    useInterval(() => {
        reloadNumbers();
    },4000);
    /* useEffect(() => {
        if(!firstLoad && !invoiceId){
            reloadNumbers();
        }
            
        const intervalId = setInterval(() =>{
            reloadNumbers();
        },5000);
        return () => clearInterval(intervalId);
    }, []); */

    
    const reloadNumbers = () =>{
        if(invoiceId || sendingRequestLoad) return;
        data.GetData().then(res => {
            if(firstLoad) return checkNumbers(res.result?.count||0, res.result?.data);

            if(res.result?.count)
                setNumOfInvoices(res.result?.count||0)
            setFirstLoad(true);
        });
    }

    
    const checkNumbers = (num, data) => {
        if(num<=numOfInvoices)return;
        
        NotificationManager.success(`${data[0].Id}`, `Invoice received`);
        if(onExecute) onExecute(data[0]);
    }


    const executeJsonCommand = () =>{
        setSendingRequestLoad(true);
        setResponse("");
        const ddd = DDD.WithConnectionKey(apiRequestAddress, integrationDevice);
        ddd.DDDI_Save(json).then((res) => {
            setSendingRequestLoad(false);
            setResponse(res);
            if(onExecute)
                onExecute(res);
        });
    }

    const onModeChange = (e, val) =>{
        setMode(val);
    }

    useEffect(()=>{
        if(invoiceId)
            setLastFieldChange("Id");
    },[invoiceId])

    return(<>
    <Row className = "g-5">
        <Col className="col-md-6 order-md-last">
        <Box sx={{ width: '100%',  borderRadius:"5px",  }}>
            <Tabs value={mode} onChange={onModeChange} aria-label="icon label tabs" centered>
                <Tab value="Website" label="Execute here" />
                <Tab value="Quick" label="cUrl/JS" />
                <Tab value="Local" label="POST" />
            </Tabs>
        </Box>
        <div className={classes["steps-wrapper"]}>
            {mode === "Quick" && <>
                <p>The object is ready to be send to our API. Copy the code below and execute it from your own machine</p>
                <Curl
                currentCurl={curlCommand}
                currentJson={json}
                activeApi="DDDI_Save"
                connectionKey={integrationDevice}
                id="curlCmd"
                />
            </>}
            {mode === "Website" && <>
                <p>To quickly create an invoice you can send the object payload by clicking the execute button below.</p>
                <Button id="executeBtn" style={{fontSize:"2rem", marginTop:"1rem", marginBottom:"1rem"}} onClick={executeJsonCommand}><CloudUploadIcon style={{marginRight:"1rem"}}/>Execute</Button>
                {sendingRequestLoad && (<LoadingDots />)}
            </>}
            {mode === "Local" && <>
                <p>POST the payload on the left side to the following:</p>
                <div className="text-start">Url:</div>
                <div className={classes["code-snippet1"]}>
                    {tx(`https://${window.location.hostname}/api/service/EUeInvoices.DDDI_Save`)}
                </div>
                <div className="text-start">Headers:</div>
                <div className={classes["code-snippet1"]}>
                    <span style={{color:"#f92672"}}>Authorization</span>: IoT {integrationDevice}:EUeInvoices
                </div>
                {/* <div className="text-start">Payload:</div>
                <div className={classes["code-snippet1"]}>
                    
                </div> */}
            </>}
            {/* {mode === "Local" && <><div>The object is ready to be send to our API. Copy the code below and execute it from your own machine</div>
            <Curl
            currentCurl={curlCommand}
            currentJson={json}
            activeApi="DDDI_Save"
            connectionKey={integrationDevice}
            id="curlCmd"
            />
            Or send a POST requesto to the following:
            </>}
            {mode === "Website" && <>
                The object is ready to be send to our API. Click execute to get a response.
                <Button id="executeBtn" style={{fontSize:"2rem", marginTop:"1rem", marginBottom:"1rem"}} onClick={executeJsonCommand}><CloudUploadIcon style={{marginRight:"1rem"}}/>Execute</Button>
                {sendingRequestLoad && (<LoadingDots />)}
            </>} */}
            {!sendingRequestLoad && response!==null && (
            <div style={{textAlign : "left", paddingTop : "5px"}} id="execute-json-response">
                <JsonObject response={response} />
            </div>
            )}
        </div>
        </Col>
        <Col className="col-md-5">
            <div className={classes["form-wrapper"]} style={{textAlign : "left"}} >
                <JSONPretty data={json} fieldName={lastFieldChange} idToScroll="executePrettyScroll"></JSONPretty>
            </div>
        </Col>
        <Col className="my-auto p-0 m-0">
            <div ><ArrowForwardIcon style={{fontSize:"2rem"}}/></div>
        </Col>
    </Row>
    </>)
}
export default Execute;